__turbopack_context__.v({
  "modalBody": "OrderFormatSelectionModal-module-scss-module__4TLv_W__modalBody",
});
